import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, NavLink } from "react-router-dom";
import {
  Rocket, ChevronDown, Menu, X, Layers, Cpu, Bot, ShoppingBag,
  GraduationCap, Heart, Store, TrendingUp, Users, Shield,
  HelpCircle, Mail, Sparkles, Scale, CreditCard, QrCode,
  BarChart3, Gift, ArrowLeftRight, Globe, Briefcase, Send, UserPlus
} from "lucide-react";
import { useT, LANGUAGES } from "./i18n";

/* ═════════════════════════════════════════════════════════════════
   HEADER — Только участниковая навигация. Инвесторов нет.
═════════════════════════════════════════════════════════════════ */
function useMenu(t) {
  return [
    {
      id: "ecosystem", label: t("nav.ecosystem"),
      items: [
        { to: "/",              icon: <Layers size={18} />,   title: t("header.ecosystem.home.title"),       desc: t("header.ecosystem.home.desc") },
        { to: "/how-it-works",  icon: <Sparkles size={18} />, title: t("header.ecosystem.how_it_works.title"),    desc: t("header.ecosystem.how_it_works.desc") },
        { to: "/ai-agent",      icon: <Bot size={18} />,      title: "Turbo AI-Agent",desc: t("header.ecosystem.ai_agent.desc") },
        { to: "/stats",         icon: <BarChart3 size={18} />,title: "Live Stats",    desc: t("header.ecosystem.stats.desc") },
      ],
    },
    {
      id: "products", label: t("nav.products"),
      items: [
        { to: "/app-info",        icon: <Rocket size={18} />,      title: t("header.products.app.title"), desc: t("header.products.app.desc") },
        { to: "/pay",             icon: <QrCode size={18} />,      title: "Turbo Pay",           desc: t("header.products.pay.desc") },
        { to: "/card",            icon: <CreditCard size={18} />,  title: "Visa Card",           desc: t("header.products.card.desc") },
        { to: "/staking-info",    icon: <TrendingUp size={18} />,  title: t("header.products.staking.title"),            desc: t("header.products.staking.desc") },
        { to: "/referral-program",icon: <Gift size={18} />,        title: t("header.products.referral.title"),            desc: t("header.products.referral.desc") },
        { to: "/exchange",        icon: <ArrowLeftRight size={18} />, title: t("header.products.exchange.title"),            desc: t("header.products.exchange.desc") },
        { to: "/swift",           icon: <Send size={18} />,        title: t("header.products.swift.title"),      desc: t("header.products.swift.desc") },
        { to: "/p2p",             icon: <Users size={18} />,       title: "P2P Exchange",        desc: t("header.products.p2p.desc") },
        { to: "/acquiring",       icon: <Briefcase size={18} />,   title: t("header.products.acquiring.title"), desc: t("header.products.acquiring.desc") },
        { to: "/marketplace",     icon: <ShoppingBag size={18} />, title: "Marketplace",         desc: t("header.products.marketplace.desc") },
        { to: "/academy",         icon: <GraduationCap size={18} />, title: "Academy",           desc: t("header.products.academy.desc") },
        { to: "/charity",         icon: <Heart size={18} />,       title: "Bear Charity",        desc: t("header.products.charity.desc") },
      ],
    },
    {
      id: "company", label: t("nav.company"),
      items: [
        { to: "/team",     icon: <Users size={18} />,      title: t("header.company.team.title"),     desc: t("header.company.team.desc") },
        { to: "/security", icon: <Shield size={18} />,     title: t("header.company.security.title"),desc: t("header.company.security.desc") },
        { to: "/faq",      icon: <HelpCircle size={18} />, title: "FAQ",         desc: t("header.company.faq.desc") },
        { to: "/legal",    icon: <Scale size={18} />,      title: "Legal",       desc: t("header.company.legal.desc") },
        { to: "/contact",  icon: <Mail size={18} />,       title: t("header.company.contact.title"),    desc: t("header.company.contact.desc") },
      ],
    },
  ];
}

export function SiteHeader() {
  const { t } = useT();
  const [open, setOpen] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const closeRef = useRef();
  const location = useLocation();
  const MENU = useMenu(t);

  useEffect(() => { setMobileOpen(false); setOpen(null); }, [location.pathname]);

  const handleItemEnter = (id) => { clearTimeout(closeRef.current); setOpen(id); };
  const handleItemLeave = () => { closeRef.current = setTimeout(() => setOpen(null), 180); };

  return (
    <header className="tg-nav" data-testid="site-header">
      <div className="tg-nav-inner">
        <Link to="/" className="tg-logo" data-testid="site-logo">
          <img src="/tgc-logo.png" alt="TGC" style={{ width: 110, height: 110, objectFit: "contain", filter: "drop-shadow(0 0 14px rgba(255,200,50,0.55))" }} />
          <span style={{ fontSize: 28 }}>TURBO <span style={{ color: "#00F2FF" }}>GLOBAL</span></span>
        </Link>

        <nav className="tg-nav-menu" role="menubar">
          {MENU.map((cat) => (
            <div key={cat.id}
              onMouseEnter={() => handleItemEnter(cat.id)}
              onMouseLeave={handleItemLeave}>
              <button className={`tg-nav-item ${open === cat.id ? "open" : ""}`}
                data-testid={`nav-cat-${cat.id}`} aria-haspopup="true">
                {cat.label}
                <ChevronDown size={14} className="chev" />
              </button>
              {open === cat.id && (
                <div className="tg-dropdown" data-testid={`dropdown-${cat.id}`}
                  style={{ minWidth: cat.items.length > 8 ? 560 : 420 }}>
                  {cat.items.map((item) => (
                    <Link key={item.to} to={item.to} className="tg-dropdown-link"
                      data-testid={`nav-link-${item.to.replace(/\W/g, "-")}`}>
                      <div className="tg-dropdown-icon">{item.icon}</div>
                      <div>
                        <div className="tg-dropdown-title">{item.title}</div>
                        <div className="tg-dropdown-desc">{item.desc}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className="tg-nav-spacer" />

        <LanguageSwitcher />
        <Link to="/login" className="tg-nav-btn ghost" data-testid="nav-login">{t("nav.login")}</Link>
        <Link to="/register" className="tg-nav-btn primary" data-testid="nav-register">
          <Gift size={14} /> {t("nav.register")}
        </Link>

        <button className="tg-nav-burger" onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={t("header.burger.aria_label")} data-testid="nav-burger">
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="tg-nav-mobile open" data-testid="nav-mobile">
          {MENU.map((cat) => (
            <React.Fragment key={cat.id}>
              <a className="section">{cat.label}</a>
              {cat.items.map((item) => (
                <NavLink key={item.to} to={item.to}>{item.title}</NavLink>
              ))}
            </React.Fragment>
          ))}
          <Link to="/login" className="tg-nav-btn ghost" style={{ marginTop: 16, textAlign: "center", justifyContent: "center" }}>{t("nav.login")}</Link>
          <Link to="/register" className="tg-nav-btn primary" style={{ textAlign: "center", justifyContent: "center" }}>
            <Gift size={14} /> {t("nav.register")}
          </Link>
        </div>
      )}
    </header>
  );
}

/* ═════ Language Switcher ═════ */
function LanguageSwitcher() {
  const { lang, setLang } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  useEffect(() => {
    const off = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("click", off);
    return () => document.removeEventListener("click", off);
  }, []);
  return (
    <div style={{ position: "relative" }} ref={ref}>
      <button className="lang-btn" onClick={() => setOpen(!open)} data-testid="lang-btn">
        <Globe size={14} /> {current.flag} <span style={{ marginLeft: 2 }}>{current.code.toUpperCase()}</span>
        <ChevronDown size={12} />
      </button>
      {open && (
        <div className="lang-dropdown" data-testid="lang-dropdown">
          {LANGUAGES.map((l) => (
            <button key={l.code} onClick={() => { setLang(l.code); setOpen(false); }}
              className={`lang-item ${l.code === lang ? "active" : ""}`}
              data-testid={`lang-item-${l.code}`}>
              <span style={{ fontSize: 18 }}>{l.flag}</span>
              <span style={{ flex: 1 }}>{l.name}</span>
              <span style={{ color: "var(--tg-text-hint)", fontSize: 11, textTransform: "uppercase" }}>{l.code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

/* ═══ Footer ═══ */
export function SiteFooter() {
  const { t } = useT();
  const MENU = useMenu(t);
  return (
    <footer className="tg-footer" data-testid="site-footer">
      <div className="tg-page">
        <div className="tg-footer-grid">
          <div>
            <div className="tg-logo" style={{ marginBottom: 16 }}>
              <img src="/tgc-logo.png" alt="TGC" style={{ width: 220, height: 220, objectFit: "contain", filter: "drop-shadow(0 0 18px rgba(255,200,50,0.6))" }} />
              <span style={{ fontSize: 36 }}>TURBO <span style={{ color: "#00F2FF" }}>GLOBAL</span></span>
            </div>
            <p style={{ color: "var(--tg-text-dim)", fontSize: 14, lineHeight: 1.6, maxWidth: 320 }}>
              {t("footer.tagline")}
            </p>
            <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
              {[
                { label: "TG", href: "https://t.me/turboglobalcoin" },
                { label: "YT", href: "https://youtube.com/@turboglobalcoin" },
                { label: "X",  href: "https://twitter.com/turboglobalcoin" },
                { label: "@",  href: "mailto:support@turbo.global" },
              ].map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer"
                  style={{ width: 36, height: 36, borderRadius: 10, border: "1px solid var(--tg-border)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    color: "var(--tg-text-dim)", fontWeight: 700, fontSize: 12 }}>
                  {s.label}
                </a>
              ))}
            </div>
          </div>
          {MENU.map((cat) => (
            <div key={cat.id} className="tg-footer-col">
              <h4>{cat.label}</h4>
              {cat.items.slice(0, 8).map((i) => <Link key={i.to} to={i.to}>{i.title}</Link>)}
            </div>
          ))}
        </div>
        <div className="tg-footer-bottom">
          <div>© 2026 Turbo Global Coin Ltd. · {t("footer.rights")}</div>
          <div>1 TGC = $0.10 · Supply: 1,000,000,000</div>
        </div>
      </div>
    </footer>
  );
}

/* ═══ Layout wrapper ═══ */
export function SiteLayout({ children }) {
  return (
    <div className="site-root">
      <SiteHeader />
      {children}
      <SiteFooter />
    </div>
  );
}